"use client";
import React, { useEffect, useState } from 'react';
import './Step3.css';
import PropTypes from 'prop-types';
import useSiniestrosStore from '../../../store/siniestrosStore';
import { getToken } from '../../../utils/claimManager';
import { VehicleStep3, ThingsStep3, Loader } from '../../../components';
import { Button } from 'atm-global-stylish/dist';
import { useNavigate } from 'react-router-dom';
import ClaimantDataForm from '../../../components/FormStep3/ClaimantDataForm';
import { companias } from '../../../utils/Companias';
import { isEmpty, showModal } from '../../../utils/functions';

const Step3 = ({ avanzar, retroceder, config, loader, handleUpdateClaim, instance, getInstance, clearInstance }) => {
  const { loading } = useSiniestrosStore();
  const navigation = useNavigate()
  const [subStep, setSubStep] = useState(null);

  const [formData, setFormData] = useState({
    who_start_the_claim: '',
    claimant_vehicle_name: '',
    claimant_vehicle_dni: '',
    claimant_vehicle_address: '',
    claimant_vehicle_phone: '',
    claimant_vehicle_phone_area: '',
    claimant_vehicle_phone_number: '',
    claimant_vehicle_mail: '',
    claimant_person_is_vehicle_owner: '',
    owner_vehicle_name: '',
    owner_vehicle_address: '',
    owner_vehicle_mail: '',
    owner_vehicle_cuit: '',
    owner_vehicle_phone: '',
    contact_name: '',
    contact_addr: '',
    contact_mail: '',
    contact_cuit: '',
    contact_phone_area: '',
    contact_phone_number: '',
    contact_phone: '',
    owner_vehicle_plate: '',
    owner_vehicle_brand: '',
    owner_vehicle_model: '',
    owner_vehicle_sub_model: '',
    owner_vehicle_brand_name: '',
    owner_vehicle_model_name: '',
    owner_vehicle_year: '',
    owner_vehicle_damage: '',
    owner_vehicle_phone_area: '',
    owner_vehicle_phone_number: '',
    owner_vehicle_insurance_company: '',
    owner_vehicle_insurance_number: '',
    things_text: '',
    things_code: '',
  });

  const [options_claim_start, setOptionsClaimStart] = useState([{ value: "", title: "Seleccione la relación *" }]);
  const [errors, setErrors] = useState({});
  const [options_rodado, setOptionsRodado] = useState([{ value: "", title: "Seleccione el tipo de rodado *" }]);
  const [options_companies, setOptionsCompanies] = useState([{ value: "", title: "Seleccione la aseguradora *" }]);

  useEffect(() => {
    if (instance) {
      if (!instance?.atm_sinister_number || !instance?.sinister_type) {
        clearInstance();
        navigation('/');
      }
    }
    const token = getToken();

    if (!token) {
      clearInstance();
      navigation('/');
    }
  }, []);

  useEffect(() => {
    setOptionsRodado([
      { value: '0', title: "Tipo de rodado *" },
      { value: '15', title: "Bicicleta" },
      { value: '17', title: "Monopatín" },
    ]);
    setOptionsCompanies([
      { value: "", title: "Seleccione la aseguradora *" },
      ...companias
    ]);

  }, []);

  useEffect(() => {
    if (instance) {
      setSubStep(instance?.step === '3.2' ? 2 : 1);
      const mappedData = {};
      for (const key in formData) {
        if (instance.hasOwnProperty(key) && instance[key] !== undefined && instance[key] !== null) {
          mappedData[key] = instance[key];
        }
      }
      setFormData(prev => ({ ...prev, ...mappedData }));
    }

  }, [instance]);

  useEffect(() => {
    if (config?.claim_start) {
      const entries = Object.entries(config.claim_start);

      const filtered = entries.slice(1);

      setOptionsClaimStart([
        { value: "", title: "Seleccione la relación *" },
        ...filtered.map(([key, value]) => ({
          value: key,
          title: value,
        })),
      ]);
    }
  }, [config.claim_start]);

  const digitsOnly = (v = "") => (v || "").replace(/\D+/g, "");

  const validatePhoneParts = (area, number) => {
    const a = digitsOnly(area);
    const n = digitsOnly(number);
    if (!a && !n) return { hasAny: false, valid: false };
    if (!a || !n) return { hasAny: true, valid: false };
    if (a.length > 4) return { hasAny: true, valid: false };
    if (n.length > 8) return { hasAny: true, valid: false };
    if (a.startsWith("0")) return { hasAny: true, valid: false };
    if (a.length === 2 && a !== "11") return { hasAny: true, valid: false };
    if (a.length + n.length !== 10) return { hasAny: true, valid: false };
    return { hasAny: true, valid: true };
  };

  const validateEmail = (value) => {
    const regex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
    return regex.test(value);
  };

  const validateLicence = (license, branch) => {
    const motorcycleOld = /^[0-9]{3}[a-zA-Z]{3}$/;
    const motorcycleNew = /^[a-zA-Z]{1}[0-9]{3}[a-zA-Z]{3}$/;
    const carOld = /^[a-zA-Z]{3}[0-9]{3}$/;
    const carNew = /^[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}$/;
    if (license === 'A DECLARAR') return true;
    switch (parseInt(branch)) {
      case 3: return carOld.test(license) || carNew.test(license);
      case 4: return motorcycleOld.test(license) || motorcycleNew.test(license);
      default: return false;
    }
  };

  const validateFieldsStep1 = () => {
    const required = [
      'who_start_the_claim',
      'claimant_vehicle_name',
      'claimant_vehicle_dni',
      'claimant_vehicle_address',
      'claimant_vehicle_mail',
    ];
    if (instance?.things !== '0') required.push('claimant_person_is_vehicle_owner');
    if (formData.who_start_the_claim !== '0' && formData.who_start_the_claim !== '3') {
      required.push(
        'contact_name',
        'contact_addr',
        'contact_mail',
        'contact_cuit',
      )
    }
    const newErrors = {};

    required.forEach(field => {
      const value = formData[field]?.trim();
      if (!value) { newErrors[field] = true; return; }
      switch (field) {
        case 'claimant_vehicle_name':
          if (value.length < 3) newErrors[field] = true;
          break;
        case 'claimant_vehicle_dni':
          if (!/^\d{8,}$/.test(value)) newErrors[field] = true;
          break;
        case 'claimant_vehicle_mail':
          if (!validateEmail(value) || value.length < 10) newErrors[field] = true;
          break;
        case 'claimant_vehicle_address':
          if (value.length < 3) newErrors[field] = true;
          break;
        default:
          break;
      }
    });

    // validate phone claimamt
    const { hasAny, valid } = validatePhoneParts(
      formData.claimant_vehicle_phone_area,
      formData.claimant_vehicle_phone_number
    );

    if (!hasAny || !valid) {
      newErrors.claimant_vehicle_phone = true;
    } else {
      const full = `${digitsOnly(formData.claimant_vehicle_phone_area)}${digitsOnly(formData.claimant_vehicle_phone_number)}`;
      if (/^\d{10}$/.test(full)) {
        if (formData.claimant_vehicle_phone !== full) {
          setFormData(prev => ({ ...prev, claimant_vehicle_phone: full }));
        }
      } else {
        newErrors.claimant_vehicle_phone = true;
      }
    }

    // validate phone contact
    if (formData.who_start_the_claim !== '0' && formData.who_start_the_claim !== '3') {
      required.forEach(field => {
        const value = formData[field]?.trim();
        if (!value) { newErrors[field] = true; return; }
        switch (field) {
          case 'contact_name':
            if (value.length < 3) newErrors[field] = true;
            break;
          case 'contact_cuit':
            if (!/^\d{8,}$/.test(value)) newErrors[field] = true;
            break;
          case 'contact_mail':
            if (!validateEmail(value) || value.length < 10) newErrors[field] = true;
            break;
          case 'contact_addr':
            if (value.length < 3) newErrors[field] = true;
            break;
          default:
            break;
        }
      });

      const { hasAny, valid } = validatePhoneParts(
        formData.contact_phone_area,
        formData.contact_phone_number
      );

      if (!hasAny || !valid) {
        newErrors.contact_phone = true;
      } else {
        const full = `${digitsOnly(formData.contact_phone_area)}${digitsOnly(formData.contact_phone_number)}`;
        if (/^\d{10}$/.test(full)) {
          if (formData.contact_phone !== full) {

            setFormData(prev => ({ ...prev, contact_phone: full }));
          }
        } else {
          newErrors.contact_phone = true;
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const validateFieldsStep2 = () => {
    const newErrors = {};
    const isOwner = formData.claimant_person_is_vehicle_owner === '1';
    const responseError = { error: true, title: 'No se pudo continuar', msg: 'Por favor, asegurate que todos los campos obligatorios estén completos y correctos.' };

    let required = [];

    required = ['owner_vehicle_brand', 'owner_vehicle_model', 'owner_vehicle_year', 'owner_vehicle_insurance_company'];
    if (instance?.things === '2' || instance?.things === '3') {
      required.push(...['owner_vehicle_plate', 'owner_vehicle_damage']);
      const branch = (((instance?.things === '2') && 3) || ((instance?.things === '3') && 4));
      if (!validateLicence(formData.owner_vehicle_plate, branch)) {
        newErrors.owner_vehicle_plate = true;
        responseError.title = '';
        responseError.msg = 'Asegurate que la patente ingresada corresponda con el tipo de vehículo del reclamo seleccionado.'
      }
    } else {
      required.push(...['things_text', 'things_code']);
    }

    if (!isOwner) {
      required.push(...['owner_vehicle_name', 'owner_vehicle_cuit', 'owner_vehicle_address', 'owner_vehicle_mail']);
      if (!validateEmail(formData.owner_vehicle_mail)) {
        newErrors.owner_vehicle_mail = true;
      }
    }

    if (!isOwner) {
      const { hasAny, valid } = validatePhoneParts(
        formData.owner_vehicle_phone_area,
        formData.owner_vehicle_phone_number
      );

      if (!hasAny || !valid) {
        newErrors.owner_vehicle_phone = true;
      } else {
        const full = `${digitsOnly(formData.owner_vehicle_phone_area)}${digitsOnly(formData.owner_vehicle_phone_number)}`;
        if (/^\d{10}$/.test(full)) {
          if (formData.owner_vehicle_phone !== full) {
            setFormData(prev => ({ ...prev, owner_vehicle_phone: full }));
          }
        } else {
          newErrors.owner_vehicle_phone = true;
        }
      }
    }

    required.forEach(field => {
      const value = formData[field]?.trim?.() ?? formData[field];
      if (!value) {
        newErrors[field] = true;
      }
    });

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      responseError.error = false;
    }

    return responseError;
  };

  const handleSubmitStep1 = async () => {
    if (!validateFieldsStep1()) {
      await showModal('No se pudo continuar', 'Por favor, asegurate que todos los campos obligatorios estén completos y correctos.', 'warning');
      return { ok: false, data: null };
    }
    if (formData.who_start_the_claim === "4" && formData.claimant_person_is_vehicle_owner === '1') {
      await showModal('No se puede continuar con la operación', 'El reclamante no puede figurar como apoderado y propietario a la vez.', 'warning');
      return { ok: false, data: null };
    }

    const token = getToken();
    const step1Data = {
      who_start_the_claim: formData.who_start_the_claim,
      claimant_vehicle_name: formData.claimant_vehicle_name,
      claimant_vehicle_dni: formData.claimant_vehicle_dni,
      claimant_vehicle_phone: formData.claimant_vehicle_phone,
      claimant_vehicle_address: formData.claimant_vehicle_address,
      claimant_vehicle_mail: formData.claimant_vehicle_mail,
      claimant_person_is_vehicle_owner: formData.claimant_person_is_vehicle_owner,
      contact_name: formData.contact_name,
      contact_addr: formData.contact_addr,
      contact_mail: formData.contact_mail,
      contact_cuit: formData.contact_cuit,
      contact_phone: formData.contact_phone,
    };

    const cleanParams = Object.fromEntries(
      Object.entries(step1Data).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
    );
    try {
      const success = await handleUpdateClaim(token, cleanParams);
      return { ok: !!success, data: step1Data };
    } catch (err) {
      await showModal('¡UPS! Hubo un error al actualizar el reclamo', err.message || 'Error desconocido al momento de la actualización del reclamo. Intente nuevamente más tarde.', 'error');
      return { ok: false, data: null };
    }
  };

  const handleSubmitStep2 = async () => {
    const responseValidation = validateFieldsStep2();

    if (responseValidation.error === true) {
      await showModal(responseValidation.title, responseValidation.msg);
      return false;
    }

    const step2Data = Object.fromEntries(
      Object.entries(formData).filter(([key, value]) =>
        [
          'owner_vehicle_name',
          'owner_vehicle_address',
          'owner_vehicle_mail',
          'owner_vehicle_cuit',
          'owner_vehicle_phone',
          'owner_vehicle_plate',
          'owner_vehicle_brand',
          'owner_vehicle_model',
          'owner_vehicle_sub_model',
          'owner_vehicle_brand_name',
          'owner_vehicle_model_name',
          'owner_vehicle_year',
          'owner_vehicle_damage',
          'owner_vehicle_insurance_company',
          'owner_vehicle_insurance_number',
          'things_text',
          'things_code'
        ].includes(key) && (value || value === 0 || value === '0') // valido el value como 0 o '0' ya que hay submodelos que tienen valor 0
      )
    );

    try {
      console.log(step2Data);
      const response = await handleUpdateClaim(getToken(), step2Data);
      if (response?.data?.errors?.length > 0 || response?.data?.success === false) {
        await showModal('Hubo un error inesperado', response?.data?.errors?.[0] || response?.data?.message || 'Ocurrió un error inesperado al continuar con la operación.', 'error');
        return;
      }

      const responseInstance = await getInstance(getToken());

      if (instance?.things !== '1' && isEmpty(responseInstance.owner_vehicle_plate)) {
        await showModal('No se pudo continuar', 'Por favor, asegurate que todos los campos obligatorios estén completos y correctos.', 'warning');
      } else {
        avanzar(4);
      }
    } catch (err) {
      await showModal('¡UPS! Algo no salió como se esperaba', 'Hubo un error desconocido en la actualización del reclamo, intente nuevamente más tarde', 'error');
    }
  };

  const handleChange = (field) => (eOrVal) => {
    const value = eOrVal?.target ? eOrVal.target.value : eOrVal;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const nextStep = async () => {
    const tipo = instance?.things;
    const isOwner = formData.claimant_person_is_vehicle_owner;
    const { ok, data } = await handleSubmitStep1();

    if (!ok) return;

    const responseInstance = await getInstance(getToken());

    let cont = 0;
    Object.entries(data).forEach((obj) => {
      if (obj[0] !== 'claimant_person_is_vehicle_owner') {
        if (obj[0].startsWith('claimant_') && isEmpty(responseInstance[obj[0]])) {
          cont++;
        }

        if (responseInstance?.who_start_the_claim !== '0') {
          if (obj[0].startsWith('contact_') && isEmpty(responseInstance[obj[0]])) {
            cont++;
          }
        }
      }
    });

    if (cont > 0) {
      await showModal('No se pudo continuar', 'Por favor, asegurate que todos los campos obligatorios estén completos y correctos.');
    } else {
      //Si es auto/moto y si es dueño
      if ((tipo === '3' || tipo === '2' || tipo === '1') && isOwner === '1') {
        setSubStep(2);
        await handleUpdateClaim(getToken(), { 'step': '3.2' });
        //Si es auto/moto/bici/casa y si no es dueño
      } else if (tipo !== '0' && isOwner === '0') {
        setSubStep(2);
        await handleUpdateClaim(getToken(), { 'step': '3.2' });
        //Restantes
      } else {
        avanzar();
      }
    }
  };

  const backSubStep = async () => {
    await handleUpdateClaim(getToken(), { 'step': '3' });
    await getInstance(getToken());
    setSubStep(1);
  }

  if (loading || loader || (subStep === null)) return <Loader />
  return (
    <div className='step1 md:w-8/12 m-auto my-8 px-5 md:px-0'>
      {(subStep === 1) &&
        <div className='flex w-full m-auto flex-col justify-center items-center gap-2'>
          <ClaimantDataForm subStep={subStep} type={instance?.things} errors={errors} formData={formData} handleChange={handleChange} options_claim_start={options_claim_start} />
          <div className='flex flex-col-reverse md:flex-row w-full justify-between gap-5 mt-8'>
            <Button handleClick={() => retroceder(2)} type='secondary' className='p-2 md:p-3' title='Volver al paso anterior' />
            <Button handleClick={nextStep} type='primary' className='p-2 md:p-3' title='Continuar' />
          </div>
        </div>
      }
      {(subStep === 2) &&
        <div className='flex w-full m-auto flex-col gap-2'>
          {(instance?.things === '4') && <ThingsStep3 errors={errors} formData={formData} handleChange={handleChange} />}
          {(instance?.things === '2' || instance?.things === '3' || instance?.things === '1') && <VehicleStep3 branch={instance?.sinister_type} type={instance?.things} options_rodado={options_rodado} options_companies={options_companies} errors={errors} isOwner={instance?.claimant_person_is_vehicle_owner} formData={formData} handleChange={handleChange} />}
          <div className='flex flex-col-reverse md:flex-row w-full justify-between gap-5 mt-8'>
            <Button handleClick={backSubStep} type='secondary' className='p-3.5' title='Volver al paso anterior' />
            <Button handleClick={() => handleSubmitStep2()} type='primary' className='p-3.5' title='Continuar' />
          </div>
        </div>
      }
    </div>
  );
};

Step3.propTypes = {
  avanzar: PropTypes.func.isRequired,
  retroceder: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  loader: PropTypes.bool.isRequired,
  handleUpdateClaim: PropTypes.func.isRequired,
};

export default Step3;
